module.exports = __webpack_public_path__ + "img/img2.f2d2eadb.png";